/**
 * PaymentsSummaryCard — тёмная сводка за период (мобилка): крупная сумма
 * «Чистыми» + три чипа (успешно/неудачно/возвраты). Локальная мини-палитра
 * тёмной карточки — как у пилюль.
 */

import {PiggyBank} from 'lucide-react';

import type {PaymentsSummary} from '@services/payments';
import {formatNumber} from '@utils/format';

import {fmtSignedSom} from '../../Payments.utils';

type PaymentsSummaryCardProps = {summary: PaymentsSummary};

export const PaymentsSummaryCard = ({summary}: PaymentsSummaryCardProps) => (
  <div className="rounded-2xl bg-skr-dark px-[18px] py-4 text-white">
    <div className="flex items-center gap-[7px] text-[12.5px] text-[#A9B0BE]">
      <PiggyBank className="size-3.5 text-skr-toast-dot" strokeWidth={2} />
      Чистыми за период
    </div>
    <div className="mt-2 whitespace-nowrap font-mono text-[30px] font-semibold -tracking-[.02em]">
      {formatNumber(summary.net)} <span className="text-sm text-[#8B93A3]">сом</span>
    </div>
    <div className="mt-3.5 flex gap-2">
      <Chip dot="#3FBF7F" label="Успешно" value={formatNumber(summary.successSum)} />
      <Chip dot="#E8746B" label="Неудачно" value={String(summary.failedCount)} />
      <Chip dot="#E0A93B" label="Возвраты" value={fmtSignedSom(summary.refundSum)} />
    </div>
  </div>
);

const Chip = ({dot, label, value}: {dot: string; label: string; value: string}) => (
  <div className="flex-1 rounded-[10px] bg-white/[.06] px-[11px] py-[9px]">
    <div className="flex items-center gap-[5px] text-[10.5px] text-[#A9B0BE]">
      <span className="size-1.5 rounded-full" style={{background: dot}} />
      {label}
    </div>
    <div className="mt-[3px] whitespace-nowrap font-mono text-sm font-semibold">{value}</div>
  </div>
);
